import { render, staticRenderFns } from "./FormworkstationtypesPage.vue?vue&type=template&id=6091a12a"
import script from "./FormworkstationtypesPage.vue?vue&type=script&lang=js"
export * from "./FormworkstationtypesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports